module.exports = __webpack_public_path__ + "img/logo_ainurse.49724b2f.png";